<template>
  <!-- img alt="Logo" class="info-energie" id="logo-iera" v-bind:src="logo_url" -->
</template>


<script>

import Vue2Leaflet from 'vue2-leaflet';
import _ from 'lodash'

export default {
    name: 'Logo',
    data () {
        return {
            logo_url: "static/img/info_energie.png",
        }
    },
    created: function() {
        var domain = window.location.hostname;
        console.log('domain:', domain);
        var white_brand_name = domain.split('.')[0];
        if (white_brand_name != '127' && white_brand_name != 'evaluer-mon-devis') {
            this.logo_url = 'static/img/' + white_brand_name + '.png';
            console.log('logos', this.logo_url);
        }
    },
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/logo.vue